import { put } from "redux-saga/effects";
import * as authTypes from "./authActionsTypes";

export default function checkAuth(err, action) {
  if (err.code === 401) {
    return put({ type: authTypes.LOGOUT_REQUEST, err });
  }

  return action;
}